import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Moon, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="py-20 px-4 bg-white" data-id="element-121">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-122">
        <div className="text-center mb-16" data-id="element-123">
          <Moon className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-124" />
          <p className="text-xl md:text-2xl font-serif text-teal leading-relaxed italic" data-id="element-125">
            "Son las 11:00 PM. Estás sentada en el silencio de tu cocina, pero
            tu mente no deja de gritar. Estás agotada de una manera que el sueño
            no puede curar."
          </p>
        </div>

        <div className="space-y-8 text-lg text-charcoal leading-relaxed" data-id="element-126">
          <p data-id="element-127">
            Sientes que si alguien te pide una sola cosa más —un vaso de agua,
            una decisión sobre la cena, un correo urgente— vas a desaparecer por
            completo.
          </p>
          <p className="font-medium text-teal text-xl" data-id="element-128">
            No es falta de voluntad. No es que seas una "mala madre". Es que tu
            sistema nervioso está incendiado y ha operado en modo de
            supervivencia por demasiado tiempo.
          </p>

          <div className="bg-sage/30 p-8 rounded-2xl mt-12 border border-sage" data-id="element-129">
            <div className="flex items-center gap-4 mb-6" data-id="element-130">
              <BatteryWarning className="w-8 h-8 text-teal" data-id="element-131" />
              <h2 className="text-2xl font-serif text-teal" data-id="element-132">
                El Peso Invisible
              </h2>
            </div>
            <p className="mb-4" data-id="element-133">
              Has pasado años cargando con el "peso invisible". Eres la CEO de
              la logística familiar, la mediadora de crisis emocionales y la
              empleada eficiente, todo al mismo tiempo. Esa presión constante ha
              elevado tus niveles de cortisol al punto que tu cuerpo ya no sabe
              cómo relajarse.
            </p>
            <p data-id="element-134">
              Vives en un estado de hipervigilancia: te sobresaltas con ruidos
              pequeños, pierdes la paciencia por tonterías y sientes una "niebla
              mental" que te hace olvidar hasta las palabras más simples. Estás
              "cansada en los huesos" y el autocuidado tradicional parece una
              broma pesada cuando no tienes ni 10 minutos para ti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}